import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AccessRequest from "@/pages/AccessRequest";
import Activate from "@/pages/Activate";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Podcasts from "@/pages/Podcasts";
import ContentDetail from "@/pages/ContentDetail";
import Testimonies from "@/pages/Testimonies";
import Meetings from "@/pages/Meetings";
import Profile from "@/pages/Profile";
import MemberLayout from "@/components/MemberLayout";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminVerifications from "@/pages/admin/AdminVerifications";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminContent from "@/pages/admin/AdminContent";
import AdminTestimonies from "@/pages/admin/AdminTestimonies";
import AdminMeetings from "@/pages/admin/AdminMeetings";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <p className="font-heading text-2xl text-muted-foreground animate-pulse">One moment…</p>
    </div>
  );
}

function Protected({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <Loading />;
  if (!user) return <Navigate to="/accedi" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/spazio" replace />;
  return children;
}

function LegacyAccessRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/request-access${search}`} replace />;
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/request-access" element={<AccessRequest />} />
          <Route path="/richiedi-accesso" element={<LegacyAccessRedirect />} />
          <Route path="/attiva" element={<Activate />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/accedi" element={<Login />} />

          <Route element={<Protected><MemberLayout /></Protected>}>
            <Route path="/spazio" element={<Dashboard />} />
            <Route path="/ascolti" element={<Podcasts />} />
            <Route path="/ascolti/:id" element={<ContentDetail />} />
            <Route path="/testimonianze" element={<Testimonies />} />
            <Route path="/incontri" element={<Meetings />} />
            <Route path="/profilo" element={<Profile />} />
          </Route>

          <Route path="/admin" element={<Protected roles={["admin"]}><AdminLayout /></Protected>}>
            <Route index element={<Navigate to="/admin/verifiche" replace />} />
            <Route path="verifiche" element={<AdminVerifications />} />
            <Route path="utenti" element={<AdminUsers />} />
            <Route path="contenuti" element={<AdminContent />} />
            <Route path="testimonianze" element={<AdminTestimonies />} />
            <Route path="incontri" element={<AdminMeetings />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
